import { Injectable } from '@angular/core';
import { SalesOrder } from '../interfaces/sales-order';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesOrderCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/salesOrders/' ;
  }

  // Create SalesOrder
  add(record: SalesOrder) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single SalesOrder Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch SalesOrders List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update SalesOrder Object
  update(record: SalesOrder) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<SalesOrder>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete SalesOrder Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}